/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/hab_open_rich': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16.4 19.207c1.051-.262 1.6-1 1.6-2s-1-2-2-2-2 1-2 2 .582 1.738 1.6 2c-.6 0-1.6 1-1.6 3V26h4v-3.793c0-2-1-3-1.6-3zM28 15.207h-5.707L16 8.914l-6.293 6.293H4v-1h5.293L16 7.5l6.707 6.707H28z"/><path pid="1" d="M28 13.207h-4.414L16 5.621l-7.586 7.586H4v-2h3.586L16 2.793l8.414 8.414H28zM14 27h4v1h-4zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
